import { gql } from "@apollo/client"

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation UserPasswdUpdateAnon($UserPasswdUpdateInput: UserPasswdUpdateInput!) {
    UserPasswdUpdateAnon(input: $UserPasswdUpdateInput) {
      status {
        success
        name
        detail
      }
      user {
        Person {
          id
          avatar
          fullName
          urlAvatar
          code
        }
      }
    }
  }
`
